import axios from 'axios'
import { ADMIN_URL } from 'shared/app-settings';
const access_token = localStorage.getItem('access_token');
const dethitructuyenService = {
    getalldethi(body) {
        return axios.get(ADMIN_URL + 'getalldethi', {
            params: body,
            headers: {
                Authorization: `${access_token}`
            },
        });
    },

    getThongTinThanhToan(body) {
        return axios.get(ADMIN_URL + 'userInfo', {
            params: body,
            headers: {
                Authorization: `${access_token}`
            },
        });
    },

    insertThongTinThanhToan(body) {
        return axios.post(ADMIN_URL + 'insertthongtinthanhtoan', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    gethienthithanhtoan(body) {
        return axios.post(ADMIN_URL + 'gethienthithanhtoan', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    getQRCode(body) {
        return axios.post(ADMIN_URL + 'getQRCode', body);
    },

    getMoTaDeThi(body) {
        return axios.post(ADMIN_URL + 'getMoTaDeThi', body);
    },

    checkPassPay(body) {
        return axios.post(ADMIN_URL + 'checkPassPay', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    // Bốc đề thi ngẫu nhiên theo kỹ năng (typeExam/skill), tránh trùng đề đã thi
    bocDeTheoKyNang(body) {
        return axios.post(ADMIN_URL + 'boc-de-theo-ky-nang', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
}
export { dethitructuyenService };